import { useQuery } from "@tanstack/react-query";
import { getAllUsers } from "service/infoUser";

export const useAllUsers = () => {
  return useQuery({
    queryKey: ["AllUsers"],
    queryFn: getAllUsers,
  });
};
